import { SET_FIRST_PAGE } from 'root/src/client/logic/list/actionIds'

export default moduleId => ({
	type: SET_FIRST_PAGE,
	payload: moduleId,
})
